// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1I5pl"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayPktTrend/styles.scss
// module id = 2266
// module chunks = 1